// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

// api
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// feature-components
import EnergyAnalysisAppBar from '@/features/energyxplorer/components/EnergyAnalysisAppBar';

// components
import { useBreadcrumb } from '@/hooks/useBreadcrumb';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { energyGroupId } = useParams({ strict: false });

  const { currentData: selectedEnergyGroup } = useGetEnergyGroupQuery(
    { groupId: energyGroupId },
    {
      skip: !energyGroupId,
    },
  );

  useBreadcrumb(selectedEnergyGroup?.name || null);

  return (
    <>
      <Suspense>
        <EnergyAnalysisAppBar key={energyGroupId} />
      </Suspense>
      <Suspense>
        <Outlet />
      </Suspense>
    </>
  );
}
